<template>
  <div>
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="dialog = true"
    >
      Filters
    </el-button>
    <el-dialog title="Filters" :visible.sync="dialog" width="500px">
      <el-select
          v-model="band"
          placeholder="Bands"
          clearable
          filterable
          class="w100"
      >
        <el-option
            v-for="(r, i) in bands"
            :key="i"
            :label="r.name"
            :value="r.value"
        ></el-option>
      </el-select>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      band: null
    }
  },

  methods: {
    ...mapActions('bands', ['read']),

    filter() {
      this.dialog = false
      this.read({
        band: this.band
      })
    },

    clear() {
      this.band = null
      this.read()
    }
  }
}
</script>
